import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import Add_ticket from './../../assets/images/add.png';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class HiringList extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            search: '',
            status: 'all',
            profile: 'all',
            hiring_profile: [],
            hiring_status: [],
            hiring_list: [],
            isLoadMore: 1,
            activePage: 1,
            loading: 1,
            item_count: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
        };
        this.searchChange = this.searchChange.bind(this);
        this.profileChange = this.profileChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    searchChange(event) {
        this.setState({
            activePage:1,
            hiring_list:[],
            loading:1,
             search: event.target.value }, function () {
            this.HiringList();
        });
    }

    profileChange(event) {
        this.setState({activePage:1,
            hiring_list:[],
            loading:1, profile: event.target.value }, function () {
            this.HiringList();
        });
    }

    statusChange(event) {
        this.setState({activePage:1,
            hiring_list:[],
            loading:1, status: event.target.value }, function () {
            this.HiringList();
        });
    }

    download_resume(id) {
        fetch(this.state.apiUrl + '/HrmanagementRest/DownloadResume/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                var anchor = document.createElement('a');
                anchor.href = findresponse.url;
                anchor.target = '_blank';
                anchor.download = findresponse.filename;
                anchor.click();

                //window.open(findresponse.url);
                this.setState({
                    url: findresponse.url,
                    activePage: 1,
                    hiring_list: [],
                },
                    function () {
                        this.HiringList(this.state.activePage);
                    })
            })
    }

    HiringList(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/GetHiring/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    hiring_list: findresponse.hiring_list,
                    hiring_status: findresponse.hiring_status,
                    hiring_profile: findresponse.hiring_profile,
                    item_count: findresponse.item_count,
                    loading: 0
                })
            })
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/HrmanagementRest/GetHiring/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.hiring_list.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    //isLoadMore: 1,
                    hiring_list: this.state.hiring_list.concat(findresponse.hiring_list),
                })
            })
    }

    getUserRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div class="list_check">
                    <div>
                        <div class="tickets hidden-sm">
                            <ul class="tickets_head">
                                <li class="intra_col_20">Name</li>
                                <li class="intra_col_25">Profile</li>
                                <li class="intra_col_20">Interviewer</li>
                                <li class="intra_col_20">Status</li>
                                <li class="intra_col_10">Rating</li>
                                <li class="intra_col_5">Action</li>
                            </ul>
                            {
                                this.state.hiring_list.map((hiring_list, key) =>
                                    <ul class="tickets_number">
                                        <li class="intra_col_20"><Link key={key} to={`/viewCandidate/${hiring_list.id_hiring}`} name={"max"}>{hiring_list.name}</Link></li>
                                        {/* <li class="intra_col_25">{hiring_list.profile ? hiring_list.profile : '--'}</li> */}
                                        <li class="intra_col_25">
                                            {hiring_list.profile ?
                                                <div class=""><span class="">{
                                                    hiring_list.profile.split(",").map(place =>
                                                        <p >  {place} </p>
                                                    )
                                                }</span></div>
                                                : '--'}
                                        </li>
                                        <li class="intra_col_20">{hiring_list.interviewer}</li>
                                        <li class="intra_col_20"> {hiring_list.status ? hiring_list.status : '--'}</li>
                                        <li class="intra_col_10">{hiring_list.rating}</li>
                                        <li class="intra_col_5">
                                            <div class="edit_delete">
                                                <Link class="tooltips" key={key} to={`/editCandidate/${hiring_list.id_hiring}`} name={"max"}><i class="fa fa-pencil-square-o" aria-hidden="true"></i><span class="tooltiptext">Edit</span></Link>
                                                <span class="delete tooltips" onClick={() => this.download_resume(hiring_list.id_hiring)}><i class="fa fa-download" aria-hidden="true"></i><span class="tooltiptext">Download Resume</span></span>
                                            </div>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    <div class="custmer_mob hidden-md">
                        {
                        this.state.hiring_list.map((hiring_list, key) =>
                      
                        <div class="custmer_list_mob">
                        <Link key={key} to={`/viewCandidate/${hiring_list.id_hiring}`} name={"max"}>
                             <h4 class="list_title">{hiring_list.name}</h4>
                             </Link>
                             <Link key={key} to={`/viewCandidate/${hiring_list.id_hiring}`} name={"max"}>
                        <div class="wrap">
                            {hiring_list.profile ? <div class=""><span class="">{
                                hiring_list.profile.split(",").map(place =>
                                    <p >  {place} </p>
                                )
                            }</span></div>
                            : '--'}
                        </div>
                        </Link>
                        <div tabindex="0" class="onclick-menu pull-right"><i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        <ul class="onclick-menu-content">
                        <li><Link class="tooltips" key={key} to={`/editCandidate/${hiring_list.id_hiring}`} name={"max"}><a>Edit</a></Link></li>     
                        <li onClick={() => this.download_resume(hiring_list.id_hiring)}><a>Download Resume</a></li>
                        </ul>
                    </div>
                        </div>
                        
                        )
                        }
                    </div> 
                    </div>
                    {this.loadMorecount()}
                </div>
            )
        }
    }

    componentDidMount() {
        document.title = "Intranet | Hiring";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.HiringList();
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function(){
                //ticketsList();
               // window.location.reload();
            },10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function(){
              
				$(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
			});
        });
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Hiring" brecum_page="Hiring" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm"><HeaderMob page_name="Candidates" /></div>
                        <div class="top-row">
                            <div class="left-section pull-left">
                                <Link to="/addHiring" class="btn btn-sky mob">
                                    <span class="hidden-sm">Add Candidate</span>
                                    <span class="mob_icon_plus hidden-md">
                                        <img src={Add_ticket} />
                                    </span>
                                </Link>
                            </div>
                            <div class="right-section pull-right">
                                <div class="row">
                                    <div class="col-md-4 col-xs-12">
                                        <div class="searchTicket emp_dept">
                                            <input type="text" class="form-control" name="search" id="search" placeholder="Search By Name" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                        <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                                    </div>
                                    <div class="col-md-4 col-xs-12">
                                        <div class="filter filter_dept">
                                            <select class="form-control" id="profile" name="profile" onChange={this.profileChange}>
                                                <option value='all'>Select Profile</option>
                                                {
                                                    this.state.hiring_profile.map((hiring_profile, key) =>
                                                        <option value={hiring_profile.id}>{hiring_profile.name}</option>
                                                    )
                                                }
                                            </select>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-xs-12">
                                        <div class="filter filter_dept">
                                            <select class="form-control" id="status" name="status" onChange={this.statusChange}>
                                                <option value='all'>Select Status</option>
                                                {
                                                    this.state.hiring_status.map((hiring_status, key) =>
                                                        <option value={hiring_status.status}>{hiring_status.status}</option>
                                                    )
                                                }
                                            </select>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        )
    }
}
export default HiringList;


// WEBPACK FOOTER //
// ./src/components/hiring/hiringList.js